import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import {
  FormGroup,
  TagSelector,
  StatusDot,
  Tooltip,
  Icon} from "xsolla-uikit";
import {
  getFakeStatuses,
  getFakeSubs,
  getUserAvatars} from "../../data";
import { users } from "../../data/users";
import {
  PaSelectMultiple,
  PAtableFilter,
  CssFilter,
  CssSelectStatus,
  CssCounter,
  CssTh,
  CssThTd,
  CssThFilt0
} from "../uikit2";

import { subsPlans } from "../../data/subsPlans";
import { currencies } from "../../data.js";
import { allColumns } from "./PAusersSubscribers";

import {
  PApopChangeEmail,
  PApopChangeDate,
  PApopStop
} from "./PAusersSubscribersPage";
import inputTag from "xsolla-uikit/lib/input-tag";
import { PAuserLine } from "./PAuserLine";

export function PAusersSubsTable({
  columns = [],
  handleClick = () => {
    void 0;
  },
  th = true,
  type
}) {
  const [filterStatus, setFilterStatus] = useState(false);
  const [filterPlan, setFilterPlan] = useState(false);
  const [filterCurr, setFilterCurr] = useState(false);

  const [popEm, setPopEm] = useState(false);
  const [popDate, setPopDate] = useState(false);
  const [popStop, setPopStop] = useState(false);

  return (
    <FormGroup indentation="lg">

      <div className="ui-table__body">
        <div
          style={{
            padding: "24px 8px 24px 24px",
            borderBottom: "1px solid rgb(204, 204, 204)",
            paddingBottom: 16
          }}
        >
          {th && (
            <CssTh
              // cols= "1.4fr 1fr 2.3fr 3fr 1fr 1fr 1fr"
              cols= {getCols(columns)}
            >


             {columns.map((oneColName) => {


             switch (oneColName) {


              case 'status':
                return (  <CssThTd>
                  <CssThFilt0>
                    Status
                    <PAtableFilter
                      position = 'bottom'
                      tooltip="Filter by status"
                      searchable={false}
                      active={filterStatus}
                      handleFilter={setFilterStatus}
                      options={[
                        {
                          label: <StatusDot status="enabled">Active</StatusDot>,
                          customIcon: <CssCounter>12.023</CssCounter>,
                          iconAlign: "right",
                          value: "active",
                          status: "enabled"
                        },
                        {
                          label: (
                            <StatusDot status="disabled"><span style={{color: '#cacaca'}}>Canceled</span></StatusDot>
                          ),
                          value: "canceled",
                          customIcon: <CssCounter>3</CssCounter>,
                          iconAlign: "right",
                          status: "disabled"
                        },
                        {
                          label: (
                            <StatusDot status="testing">Non renewing</StatusDot>
                          ),
                          value: "renewing",
                          customIcon: <CssCounter>12</CssCounter>,
                          iconAlign: "right",
                          status: "testing"
                        },
                        {
                          label: (
                            <StatusDot status="refunded">
                              In trial
                            </StatusDot>
                          ),
                          value: "trial",
                          customIcon: <CssCounter>20.021</CssCounter>,
                          iconAlign: "right",
                          status: "processing-outline"
                        },
                        {
                          label: <StatusDot status="error">Expired</StatusDot>,
                          value: "expired",
                          customIcon: <CssCounter>354</CssCounter>,
                          iconAlign: "right",
                          status: "error"
                        }
                      ]}
                    />
                  </CssThFilt0>
                </CssThTd>)
                break;




                case 'email':
                    return (
                      <CssThTd>Email / Username or User ID</CssThTd>
                    )
                  break;


               case 'internal':
                    return (

                      <CssThTd>Internal id</CssThTd>
                    )
                  break;





               case 'dateCreation':
                    return (
                      <CssThTd>Creation date</CssThTd>
                    )
                  break;


               case 'dateNext':
                    return (
                      <CssThTd>Next charge</CssThTd>
                    )
                  break;


               case 'charge':
                    return (
                      <CssThTd>
                        <CssThFilt0
                          style={
                            {
                              // justifyContent: 'flex-end',
                            }
                          }
                        >
                          Charge
                          <PAtableFilter
                            position = 'bottom'
                            tooltip="Filter by currency"
                            align="right"
                            size="md"
                            searchable={true}
                            active={filterCurr}
                            handleFilter={setFilterCurr}
                            options={[
                              ...Object.keys(currencies).map((oneC, ind) => ({
                                label: currencies[oneC]["name"],
                                // extraLabel: currencies[oneC]["symbol"],
                                extraLabel: currencies[oneC]["code"],
                                value: currencies[oneC]["code"]
                              }))
                            ]}
                          />
                        </CssThFilt0>
                      </CssThTd>
                    )
                  break;

               case 'plan':
                    return (
                      <CssThTd>
                        <CssThFilt0>
                          Subscription plan
                          <PAtableFilter
                            position = 'bottom'
                            tooltip="Filter by subscription plan"
                            searchable={true}
                            active={filterPlan}
                            size="lg"
                            handleFilter={setFilterPlan}
                            options={subsPlans.map((sPlan, ind) => ({
                              label: sPlan["label"],
                              extraLabel: sPlan["price"],
                              value: sPlan["id"]
                            }))}

                            // options={[...subsPlans]}
                          />
                        </CssThFilt0>
                      </CssThTd>
                    )
                  break;


               case 'action':
                    return (
                      <CssThTd
                        style={{
                          display: "flex",
                          justifyContent: "flex-end"
                        }}
                      >
                        Action
                      </CssThTd>
                    )
                  break;



               default:
                  return null;
                  break;

              }})}




            </CssTh>
          )}
        </div>


        <PAusersTable
          columns={columns}
          handleEmail={setPopEm}
          handleDate={setPopDate}
          handleStop={setPopStop}
          filterPlan={filterPlan}
          filterStatus={filterStatus}
          handleClick={handleClick}
          // handleClick={(e)=>setPopEm(e)}
        />




        {popEm !== false && (
          <PApopChangeEmail handleModal={() => setPopEm(false)} />
        )}

        {popDate !== false && (
          <PApopChangeDate handleModal={() => setPopDate(false)} />
        )}

        {popStop !== false && <PApopStop handleModal={() => setPopStop(false)} />}


      </div>


    </FormGroup>
  );
}








export const PAusersTable = React.memo(props => {
  return <PAusersTable1 {...props} />;
});

export function PAusersTable1({
  columns = [],
  filterPlan,
  filterStatus,

  handleEmail = () => void 0,
  handleDate = () => void 0,
  handleStop = () => void 0,

  handleClick = () => void 0,
  type
}) {
  useEffect(() => {
    // debugger
  });

  return (
    <div className="">
      {users.map((oneUser, index) => {
        return (
          <PAuserLine
            columns={columns}
            handleEmail={handleEmail}
            handleDate={handleDate}
            handleClick={handleClick}
            handleStop={handleStop}
            hover={true}
            index={index}
            key={`userline_${index}`}
            type={type}
            purchase={[getFakeSubs(filterPlan)]}
            status={getFakeStatuses(filterStatus)}
            id={oneUser["id"]}
            nickname={oneUser["nickname"]}
            name={oneUser["name"]}
            picture={getUserAvatars()}
            // picture = {userAvatars[index]}
            // picture = {userAvatars[Math.floor(Math.random() * userAvatars.length)]}
            birthday={oneUser["birthday"]}
            first_name={oneUser["first_name"]}
            last_name={oneUser["last_name"]}
            gender={oneUser["gender"]}
            email={oneUser["email"]}
            phone={oneUser["phone"]}
            groups={[
              {
                id: 24,
                name: "default",
                is_default: true,
                is_deletable: false
              }
            ]}
            registered={oneUser["registered"]}
            external_id={oneUser["external_id"]}
            last_login={oneUser["last_login"]}
            ban={oneUser["ban"]}
            country={oneUser["country"]}
            actions={[
              {
                label: "Change user email",
                // customIcon: <StatusDot status="enabled" />,
                customIcon: <Icon name="profile" />,
                iconAlign: "right",
                onClick: () => handleEmail(index)
              },
              {
                label: "Change renewal date",
                // customIcon: <StatusDot status="enabled" />,
                customIcon: <Icon name="calendar" />,
                iconAlign: "right",
                onClick: () => handleDate(index)
              },
              {
                label: "See relevant transactions (3)"
                // customIcon: <Icon name="calendar" />,
                // iconAlign: "right",
                // onClick: () => handleDate(index)
              },

              {
                color: "#fc2b55",
                label: "Cancel and refund",
                description: (
                  <span style={{ color: "#fc2b55" }}>
                    User will receive a refund for unused days
                  </span>
                ),
                // customIcon: <StatusDot status="enabled" />,
                // customIcon: <Icon name="remove-circle" />,
                iconAlign: "right",
                onClick: () => handleStop(index)
              },
              {
                color: "#fc2b55",
                label: "Cancel whithout refund",
                description: (
                  <span style={{ color: "#fc2b55" }}>
                    User will receive a refund for unused days
                  </span>
                ),
                // customIcon: <StatusDot status="enabled" />,
                customIcon: <Icon name="remove-circle" />,
                iconAlign: "right",
                onClick: () => handleStop(index)
              }
            ]}
          />
        );
      })}
    </div>
  );
}



const getWidth = (nam) => {
  let col = allColumns.filter((oneCol) => oneCol['value'] === nam)[0];

  return col ? col['width'] : '1fr';
}

export const getCols = (columns) => {
  let ret = '';
  columns.forEach((oneColName) => {
    ret = ret ? `${ret} ${getWidth(oneColName)}` : `${getWidth(oneColName)}`
    console.log('ret = ', ret);
  })
  return ret
}




export const CssNoEmail = styled.div`
  color: #fc2b55;
`;
